import './../../../stylesheets/users/confirmations';

// ページ読み込み時の処理
document.addEventListener('turbolinks:load', function() {
  // ボランティアセンター登録の前のアクション
  ruleActions();
})

// ボランティアセンター登録の前のアクション
export function ruleActions() {
  // ボランティアセンター登録の前のフォームを取得
  let RuleForm = document.getElementById('users_members_confirmation_rule_form');

  if (!!RuleForm) {
    // 同意するボタンを取得
    let AgreeButton = RuleForm.querySelector('input[type="submit"]');

    if (!!AgreeButton) {
      // スクロールするコンテンツを取得
      let RuleScrollElements = RuleForm.querySelector('div.overflow-auto');

      if (!!RuleScrollElements) {
        let clientHeight = RuleScrollElements.clientHeight;
        let scrollHeight = RuleScrollElements.scrollHeight;

        // スクロースした時のイベント
        RuleScrollElements.onscroll = function() {
          // 一番下までスクロールしたか判定
          if (scrollHeight - (clientHeight + this.scrollTop) == 0) {
            // 同意するボタンの disabled を無効にする
            AgreeButton.disabled = false;
          }
        };
      }
    }
  }
}